const MODULE_URL = 'system';

export default {
  MODULE_URL: MODULE_URL,
  STATS_URL: MODULE_URL + '/stats',
  AWAY_STATE_URL: MODULE_URL + '/away',

  AWAY_STATE: 'away_state',
};
